import { ITEM_STATS, ItemName, ItemRarity } from "./item-types";



export const rarityOffset = (rarity: ItemRarity): string => {
    switch (rarity) {
        case ItemRarity.Gold:
        case ItemRarity.Diamond:
        case ItemRarity.Heroic:
        case ItemRarity.Food:
            return '-13px';
        case ItemRarity.Mythic: // Mythic not implemented yet
            return '0px';
        case ItemRarity.Common:
        case ItemRarity.Rare:
        case ItemRarity.Set:
        default:
            return '-12px';
    }
}

export const getFoodFromIngredients = (ingredient1: ItemName, ingredient2: ItemName) => {
    if (ingredient1 === ingredient2) {
        return null;
    }
    for (const key in ITEM_STATS) {
        const stat = ITEM_STATS[key as ItemName];
        if (
            stat.components &&
            (
                (stat.components[0] === ingredient1 && stat.components[1] === ingredient2) ||
                (stat.components[1] === ingredient1 && stat.components[0] === ingredient2)
            )
        ) {
            return key as keyof typeof ITEM_STATS;
        }
    }
    return ItemName.Unknown;
};